import React from "react";
import { Card } from "react-bootstrap";
import VerticalScrollImage from "./VerticalScrollImage";



const web =[
{name : "Mody University", link:"#", image:"../portfolioimg/modyuniversity.png", redirecturl: "#" },
{name : "Mody School", link:"#", image:"../portfolioimg/modyschool.png", redirecturl: "#" },
{name : "Online Mody University", link:"#", image:"../portfolioimg/onlinemody.png", redirecturl: "#" },
{name : "Mission Gyan", link:"#", image:"../portfolioimg/missiongyan.png", redirecturl: "#" },
{name : "Almuntasebaat", link:"#", image:"../portfolioimg/almuntasebaat.png", redirecturl: "#" },
{name : "Surat jamaat", link:"#", image:"../portfolioimg/suratjamaat.png", redirecturl: "#" },
{name : "TGL", link:"#", image:"../portfolioimg/tgl.png", redirecturl: "#" },
{name : "MS2", link:"#", image:"../portfolioimg/ms2.png", redirecturl: "#" },
{name : "Almuntasebaat Android App", link:"#", image:"../portfolioimg/almuntasebaatandroid.png", redirecturl: "#" },
{name : "MG Blog", link:"#", image:"../portfolioimg/blogmg.png", redirecturl: "#" },
{name : "shrihari Aromatics", link:"#", image:"../portfolioimg/srihari.png", redirecturl: "#" },
{name : "Jat Polo Club", link:"#", image:"../portfolioimg/jatpolo.png", redirecturl: "#" },
{name : "Jat Aviation", link:"#", image:"../portfolioimg/jataviation.png", redirecturl: "#" },
{name : "Shop Ustaad", link:"#", image:"../portfolioimg/shopustaad.png", redirecturl: "#" },
{name : "G News portal", link:"#", image:"../portfolioimg/gnews.png", redirecturl: "#" },
{name : "G Shop Android Application", link:"#", image:"../portfolioimg/gshop.webp", redirecturl: "#" },
{name : "Mission Gyan Android Application", link:"#", image:"../portfolioimg/mgandroid.png", redirecturl: "#" },
{name : "Himmat infotech", link:"#", image:"../portfolioimg/himat.png", redirecturl: "#" },
{name : "S & S interiors", link:"#", image:"../portfolioimg/ss.png", redirecturl: "#" },
{name : "SR Gems", link:"#", image:"../portfolioimg/sr.png", redirecturl: "#" },
{name : "82 Servers", link:"#", image:"../portfolioimg/82server.jpg", redirecturl: "#" },
{name : "Intellipaat", link:"#", image:"../portfolioimg/intellipaat.jpg", redirecturl: "#" },
{name : "Travelpal", link:"#", image:"../portfolioimg/travelpal.jpg", redirecturl: "#" },
{name : "Sureworth Group", link:"#", image:"../portfolioimg/sureworth.jpg", redirecturl: "#" },
{name : "Sun SG", link:"#", image:"../portfolioimg/sun-sg.jpg", redirecturl: "#" },
{name : "UK Certificates", link:"#", image:"../portfolioimg/uk-certificates.jpg", redirecturl: "#" },
{name : "HK Prints", link:"#", image:"../portfolioimg/hkprints.png", redirecturl: "#" },
{name : "Blue Ambit LED", link:"#", image:"../portfolioimg/ambit.png", redirecturl: "#" },
];



const websites = () => {
    return (
        <div className="col-md-12 row text-center">
            <h1>Our Portfolio</h1>
            <h5>We work with global brands</h5>
            <p>Check out some of our recent projects!</p>
            {/* Add portfolio items here */}
<div className="col-md-12 row">

{web.map((item, index) => (
    
<Card className="col-md-3 shadow-sm bg-light text-center mb-4 p-4" >
  <center>
   <VerticalScrollImage
      src={item.image}
        size={250}
        scrollSpeed={2}
      />
      </center>
  {/* <Card.Img variant="top" src={item.image} /> */}
  <Card.Body>
    <Card.Title>{item.name}</Card.Title>
   
    </Card.Body>
    </Card>
    
))}
    

</div>

        </div>
    );  
};

export default websites;